import { mdiChartLine } from '@mdi/js';
import Icon from '@/components/Icon';
import styles from './NavCatItem.module.css';
import Badge from '../layout/Badge';

const NavCatItem = ({ value, selected, onClick, badge }: any) => {
  return (
    <li
      onMouseEnter={e => {
        e.preventDefault();
        onClick(value);
      }}
      onMouseDown={e => {
        e.preventDefault();
        onClick(value);
      }}
      onMouseUp={e => {
        e.preventDefault();
      }}
      className={[styles.container, selected ? styles.selected : null].join(
        ' ',
      )}
    >
      <div>
        <Icon
          path={value.icon}
          size={1.75}
          color="var(--tc-color-brand-primary)"
        />
        {badge !== undefined && badge > 0 && (
          <Badge
            variant='danger'
            style={{
              position: 'absolute',
              top: 10,
              right: 10,
              fontSize: '0.75rem',
              fontWeight: 'bold',
            }}
          >
            {badge}
          </Badge>
        )}
      </div>
      <div className="label">{value?.label ?? ''}</div>
    </li>
  );
};

export default NavCatItem;
